export default __webpack_public_path__ + "static/compareItemImg1-674de5137bbc1e91752c61d6b4693184.webp";